export const CHART_PALETTE = [
  '#2d4a3e', '#b8954f', '#5a7a6a', '#d4a857',
  '#3d6a5a', '#8b6914', '#4a5a4a', '#cd853f'
]

export function CustomTooltip({ active, payload, label, formatter }) {
  if (!active || !payload?.length) return null
  return (
    <div className="bg-white rounded-lg shadow-lg border border-earth-200 px-4 py-3 text-sm">
      {label && (
        <p className="font-semibold text-earth-800 mb-1.5 border-b border-earth-100 pb-1.5">
          {label}
        </p>
      )}
      <div className="space-y-1">
        {payload.map((entry, i) => (
          <div key={i} className="flex items-center gap-2">
            <span
              className="w-2.5 h-2.5 rounded-full shrink-0"
              style={{ backgroundColor: entry.color || entry.fill }}
            />
            <span className="text-earth-600">{entry.name}:</span>
            <span className="font-semibold text-earth-900 ml-auto">
              {formatter
                ? formatter(entry.value, entry.name)
                : typeof entry.value === 'number'
                  ? entry.value.toLocaleString()
                  : entry.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export const gridProps = {
  strokeDasharray: '3 3',
  stroke: '#e5ddd0',
  strokeOpacity: 0.7,
}

export const axisTick = {
  fontSize: 11,
  fill: '#9a8a70',
  fontFamily: 'Inter, system-ui, sans-serif',
}

export const barRadius = [4, 4, 0, 0]

export const chartMargin = { top: 5, right: 10, left: 0, bottom: 5 }
